import React from 'react'

const Counter = ({setAmount, amount}) => (
  <div className='counter'>
    <button onClick={_ => setAmount(amount <= 1 ? amount : amount - 1)}>-</button>
    <input type='number' onChange={e => setAmount(parseInt(e.target.value))} value={amount}/>
    <button onClick={_ => setAmount(amount + 1)}>+</button>
  </div>
)

export default Counter
